import Swiper, { Navigation, Thumbs, Scrollbar } from 'swiper';

export default class ProductSliders {
  constructor(mainSliderSelector, thumbsSliderSelector, options = {}) {

    this.templateMain = document.querySelector('template[data-all-media-main]');
    this.templateThumbs = document.querySelector(
      'template[data-all-media-thumbs]'
    );

    this.mainSliderSelector = mainSliderSelector;
    this.thumbsSliderSelector = thumbsSliderSelector;

    this.mainSlider = document.querySelector(this.mainSliderSelector);
    this.thumbsSlider = document.querySelector(this.thumbsSliderSelector);

    this.mainSwiperInstance = null;
    this.thumbsSwiperInstance = null;
    this.options = options;
    this.isExpanded = options.isExpanded || false;
    this.initialSlide =
      typeof options.initialSlide === "number" ? options.initialSlide : 0;
  }

  createThumbSlider(currentMediaSize = 0) {
    this.thumbsSwiperInstance = new Swiper(this.thumbsSlider, {
      modules: [Navigation, Thumbs],
      spaceBetween: 24,
      slidesPerView: 8,
      threshold: 8,
      direction: 'vertical',
      loop: currentMediaSize >= 8 ? true : false,
      autoHeight: this.thumbsSlider.closest('#originalThumbsContainer') ? false : true,
    });
  }

  createMainSlider(currentMediaSize = 0) {
    if (!this.thumbsSwiperInstance) return;
    const isHypothesisActive = document.body.classList.contains("pdp-hypothesis-active");

    this.mainSwiperInstance = new Swiper(this.mainSlider, {
      modules: [Navigation, Thumbs, Scrollbar],
      initialSlide: this.initialSlide,
      watchSlidesProgress: true,
      watchOverflow: true,
      roundLengths: true,
      normalizeSlideIndex: true,
      loop: true,
      on: {
        init: (swiper) => {
          setTimeout(() => {
            document
              .querySelector(".product-skeleton")
              ?.classList.add("hidden");
            document
              .querySelector(".product-page")
              ?.classList.remove("invisible", "h-0");
          }, 200);
        },
        transitionStart: (swiper) => {
          const swiperEl =
            swiper.$el && swiper.$el[0] ? swiper.$el[0] : swiper.el;
          if (swiperEl) {
            const videos = swiperEl.querySelectorAll("video");
            Array.prototype.forEach.call(videos, (video) => {
              video.pause();
              video.currentTime = 0;
            });
          }
        },
        transitionEnd: (swiper) => {
          const activeIndex = swiper.activeIndex;
          const swiperEl =
            swiper.$el && swiper.$el[0] ? swiper.$el[0] : swiper.el;
          if (swiperEl) {
            const activeSlide =
              swiperEl.getElementsByClassName("swiper-slide")[activeIndex];
            if (activeSlide) {
              const activeSlideVideo =
                activeSlide.getElementsByTagName("video")[0];
              if (activeSlideVideo) {
                activeSlideVideo.play();
              }
            }
          }

          this.updateProgressBar(swiper);
        },
        slideChange: (swiper) => {
          this.updateProgressBar(swiper);
        },
      },
      allowSlidePrev: true,
      allowSlideNext: true,
      centeredSlides: false,
      navigation: {
        nextEl: this.isExpanded
          ? "#largeThumbsContainer .swiper-button-next"
          : "#smallThumbsContainer .swiper-button-next, #originalThumbsContainer .swiper-button-next",
        prevEl: this.isExpanded
          ? "#largeThumbsContainer .swiper-button-prev"
          : "#smallThumbsContainer .swiper-button-prev, #originalThumbsContainer .swiper-button-next",
      },
      scrollbar: {
        el: isHypothesisActive ? (this.isExpanded ? "[data-product-slider-scroll-bar-large]" : "[data-product-slider-scroll-bar-small]") : "[data-product-slider-scroll-bar]",
        draggable: true,
      },
      spaceBetween: 10,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      slidesPerGroup: 1,
      slidesPerGroupSkip: 0,
      breakpoints: {
        0: {
          slidesPerView: isHypothesisActive ? (this.isExpanded ? 1 : "auto") : 1.3,
          spaceBetween: isHypothesisActive ? (this.isExpanded ? 0 : 4) : 10,
          centeredSlides: false,
          slidesPerGroup: 1,
        },
        648: {
          slidesPerView: isHypothesisActive ? (this.isExpanded ? 2 : "auto") : 2,
          spaceBetween: isHypothesisActive ? (this.isExpanded ? 0 : 4) : 10,
          centeredSlides: false,
          slidesPerGroup: 1,

        },
        1024: {
          slidesPerView: isHypothesisActive ? (this.isExpanded ? 1 : "auto") : 1,
          spaceBetween: isHypothesisActive ? (this.isExpanded ? 0 : 4) : 0,
          centeredSlides: false,
          slidesPerGroup: 1,
        },
      },
      mousewheel: this.isExpanded
        ? {
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 1,
          }
        : {
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 0.1,
            thresholdDelta: 50,
            thresholdTime: 300,
          },

      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      allowTouchMove: true,
      touchStartPreventDefault: true,
      touchMoveStopPropagation: true,
      resistanceRatio: 0.85,
      speed: this.isExpanded ? 300 : 250,
      thumbs: {
        swiper: this.thumbsSwiperInstance,
      },
    });
    return;
  }

  updateProgressBar(swiper) {
    const progressBarSelector = this.isExpanded
      ? "[data-progress-bar-large]"
      : "[data-progress-bar-small]";
    const progressBar = document.querySelector(progressBarSelector);

    if (progressBar && swiper.slides && swiper.slides.length > 0) {
      const progress = ((swiper.realIndex + 1) / swiper.slides.length) * 100;
      progressBar.style.width = `${progress}%`;
    }
  }

  getFilteredMedia(slides, currentVariant) {
    const fragment = new DocumentFragment();
    let currentMediaSize = 0;
    slides.forEach((slide) => {
      const media = slide.querySelector('img') || slide.querySelector('video');
      const itemAlt = media.alt;
      const correctImage =
        itemAlt &&
        currentVariant.selectedOptions.every((item) => {
          const trimedValue = item.value.replace(/ /g, '').toLowerCase();
          const altWithoutSpaces = itemAlt
            .replaceAll('/', '')
            .replaceAll(' ', '')
            .toLowerCase();
          return altWithoutSpaces.includes(trimedValue);
        });
      if (correctImage) {
        fragment.appendChild(slide);
        currentMediaSize += 1;
      }
    });

    if (currentMediaSize == 0) {
      slides.forEach((slide) => fragment.appendChild(slide));
      currentMediaSize = slides.length;
    }

    return { fragment, currentMediaSize };
  }

  replaceChildren(parent, newElements) {
    const wrapper = parent.querySelector('.swiper-wrapper');
    wrapper.replaceChildren(newElements);
  }

  reinitThumbSlider(currentVariant) {
    const clonedTemplate = new DocumentFragment();
    clonedTemplate.append(this.templateThumbs.content.cloneNode(true));

    const thumbAllSlides = [...clonedTemplate.children];
    const { fragment, currentMediaSize } = this.getFilteredMedia(
      thumbAllSlides,
      currentVariant
    );

    this.replaceChildren(this.thumbsSlider, fragment);
    this.thumbsSwiperInstance?.destroy(true, true);
    this.createThumbSlider(currentMediaSize);
  }

  reinitMainSlider(currentVariant) {
    const clonedTemplate = new DocumentFragment();
    clonedTemplate.append(this.templateMain.content.cloneNode(true));

    const mainAllSlides = [...clonedTemplate.children];
    const { fragment, currentMediaSize } = this.getFilteredMedia(
      mainAllSlides,
      currentVariant
    );
    this.replaceChildren(this.mainSlider, fragment);

    this.mainSwiperInstance?.destroy(true, true);
    this.createMainSlider(currentMediaSize);
  }

  reinit(currentVariant, isBundle = false) {
    if (!currentVariant || isBundle) return;
    this.reinitThumbSlider(currentVariant);
    this.reinitMainSlider(currentVariant);
  }

  init() {
    this.createThumbSlider();
    this.createMainSlider();
  }
}